import React, { useMemo } from "react";
import { Spin, Alert, Empty } from "antd";
import PropTypes from "prop-types";

import { FaScroll } from "react-icons/fa";
import DevedorInfo from "./DevedorInfo";
import ContratoView from "./ContratoView";
import { OperatorProvider } from "./use-operators";
import { useFetchContract, FetchStatus } from "./use-fetch-contracts";

import "./styles.css";

export const Contratos = ({ id_devedor }) => {
  const { status, data, refetch } = useFetchContract(id_devedor);

  const isLoading = status === FetchStatus.LOADING;
  const isSuccess = status === FetchStatus.SUCCESS;
  const isError = status === FetchStatus.ERROR;
  const contratos = isSuccess ? data.operacao_set : [];

  return (
    <OperatorProvider>
      <div className="pasta_contratos__wrapper">
        <div className="pasta_contratos__title">
          <FaScroll />
          &nbsp;&nbsp;Contratos da Pasta
        </div>

        <hr />

        {isLoading && (
          <div className="pasta_contratos__loading">
            <Spin tip="Carregando..." />
          </div>
        )}

        {isError && (
          <div className="pasta_contratos__loading">
            <Alert
              description="Falha ao carregar as informações dos contratos."
              type="error"
            />
          </div>
        )}

        {isSuccess && (
          <div className="pasta_contratos__container">
            {/* Card Modernizado de Informações do Devedor */}
            <DevedorInfo devedor={data} />

            {/* Lista de Contratos Modernizada */}
            <div className="pasta_contratos__contratos_container">
              {contratos && contratos.length > 0 ? (
                contratos.map(contrato => (
                  <ContratoView
                    key={contrato.id}
                    operacao={contrato}
                    onUpdate={refetch}
                  />
                ))
              ) : (
                <Empty description="Nenhum contrato encontrado" />
              )}
            </div>
          </div>
        )}
      </div>
    </OperatorProvider>
  );
};

Contratos.propTypes = {
  id_devedor: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/pages/Pasta/Contratos/index.jsx